import * as React from 'react';

import { VoiceboxChatOutgoing } from 'bones/components/molecules/Voicebox/chat/VoiceboxChatOutgoing';
import { useVoiceboxSchema } from 'bones/components/molecules/Voicebox/context/VoiceboxSchema';
import { VoiceboxRequestMessage } from 'bones/constants/voicebox/message';

export interface VoiceboxChatMessageRequestProps {
  message: VoiceboxRequestMessage;
  messageIdx: number;
}

export const VoiceboxChatMessageRequest: React.VFC<
  VoiceboxChatMessageRequestProps
> = ({ message, messageIdx }) => {
  const { testIds } = useVoiceboxSchema();

  return (
    <VoiceboxChatOutgoing
      content={message.query}
      testId={testIds.messages.requestMessage(message.messageId, messageIdx)}
    />
  );
};
